import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router  } from 'react-router-dom';
import { Provider } from "react-redux"
import App from './App.js';
import * as serviceWorker from './registerServiceWorker.js';
import store from "./state/store";
import Spinner from "./components/Spinner.js";
import { history } from "./routerHistory.js";
import { fetchCookie } from 'services/cookieService.js';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
let cookie = await fetchCookie();
if (!cookie) {
    window.location.href = window.location.origin + "/Account/Login?returnUrl=" + encodeURIComponent(window.location.pathname + window.location.search);
} else {
    const root = ReactDOM.createRoot(rootElement); // Only pass the container here
    root.render(
        <Provider store={store}>
            <Router history={history}>
                <App />
                <Spinner />
            </Router>
        </Provider>
    );
}

serviceWorker.unregister();